import { useState } from "react";
import Warranty from "./components/warranty/index";
import UserInformationForm from "./components/user-information-form";
import DeviceInformationForm from "./components/device-information-form/index";
import { useNavigate, useParams } from "react-router-dom";
import useAuthUser from "../../common/hooks/authUser";
import { useRegisterDevice, useSubmitSurvey } from "../../common/hooks/api/registration";
import { toastError, toastSuccess } from "../../helpers/toast-helper";
import DeviceSurveyForm from "./components/survey-form";
import Spinner from "../../components/Common/Spinner";

const DeviceWarrantyRegistrationPage = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [step, setStep] = useState(1);
    const { user } = useAuthUser();
    const [formData, setFormData] = useState<any>({});

    const { mutate: registerDevice, isPending: isRegistrationLoading } = useRegisterDevice();
    const { mutate: submitSurvey, isPending: isSurveyLoading } = useSubmitSurvey();
    const isGlobalLoading = isRegistrationLoading || isSurveyLoading;

    const onNext = (data?: any): void => {
        if (data) {
            setFormData({
                ...formData,
                ...data,
            });
        }

        setStep((prev) => prev + 1);
    };
    const onPrev = (data) => {
        if (data) {
            setFormData({
                ...formData,
                ...data,
            });
        }
        setStep((prev) => prev - 1);
    };
    const onSubmit = (data) => {
        const finalFormData = {
            ...formData,
            ...data,
        };

        const payload = {
            userDetails: {
                user: {
                    email: user.email,
                    firstName: finalFormData.user.firstName,
                    lastName: finalFormData.user.lastName,
                    phone: finalFormData.user.phoneNumber,
                },
                company: {
                    name: finalFormData.user.company,
                    businessType: finalFormData.user.businessType,
                    machineApplication: finalFormData.user.machineApplication,
                },
                address: {
                    line1: finalFormData.user.address,
                    line2: finalFormData.user.address2,
                    city: finalFormData.user.city,
                    state: finalFormData.user.state,
                    zip: finalFormData.user.zip,
                    country: finalFormData.user.country,
                }
            },
            deviceDetailsDTO: {
                serialNumber: id,
                deliveryDate: new Date(finalFormData.device.deliveryDate).toISOString(),
                hourMeter: finalFormData.device.hourMeter === '' ? undefined : finalFormData.device.hourMeter,
                saleCondition: finalFormData.device.isNew ? "New" : "Used",
                hadTransportDamage: finalFormData.device.hasShippingOrTransportDamage,
                hadOrderedOptions: finalFormData.device.allOptionsInstalled,
            },
            isAdminRegistration: false
        };
        
        registerDevice(payload,{
            onSuccess: async () => {
                await toastSuccess("Machine registration was finished successfully");
                setStep((prev) => prev + 1);
            },
            onError: async () => {
                toastError("Cannot update machine registration data");
            },
        });
    };

    const onSubmitSurvey = (data) => {
        const payload = {
            serialNumber: id,
            answer1: formData?.user?.machineApplication ?? data.productSatisfaction,
            answer2: data.productMeetsNeeds,
            answer3: data.easeOfInformation,
            answer4: data.easeOfUse,
            answer5: data.recommendProduct,
            answer6: data.additionalQuestions,
            answer7: data.whatDealership,
            answer8: data.dealershipExperience,
            answer9: data.dealershipKnowledge,
            answer10: data.recommendDealership,
            shippingAddressDifferent: data.differentAddress,
            fullName: data.fullName,
            address1: data.address,
            address2: data.address2,
            city: data.city,
            state: data.state,
            zip: data.zip,
            welcomeGiftOption: data.welcomeGift,
            answer11: data.hasManual,
            answer12: data.dealerReviewMaintenanceProcedures,
            answer13: data.dealerReviewSafetyProcedures
        }

        submitSurvey(payload,{
            onSuccess: async () => {
                await toastSuccess("Survey responses submitted successfully");
                navigate(`/machines?confirmation=${id}`);
            },
            onError: async () => {
                toastError("Failed to send survey responses");
            },
        });
    }

    return (
        
        
        <div
        className="position-relative"
        style={{
            minHeight: "60vh", // ensure enough height to center
        }}
        >
        {isGlobalLoading && (
            <div style={{ position: "absolute", inset: 0, zIndex: 1000 }}>
            <Spinner />
            </div>
        )}

        {/* Your existing step blocks */}
        {step === 1 && (<Warranty onNext={onNext} deviceSerialNumber={id!} />)}
        {step === 2 && (
            <UserInformationForm
            onNext={onNext}
            onPrev={onPrev}
            deviceSerialNumber={id!}
            user={user}
            data={formData?.user}
            />
        )}
        {step === 3 && (
            <DeviceInformationForm
            onNext={onSubmit}
            onPrev={onPrev}
            deviceSerialNumber={id!}
            data={formData?.device}
            isRegistrationLoading={isRegistrationLoading}
            />
        )}
        {step === 4 && (
            <DeviceSurveyForm
            onNext={onSubmitSurvey}
            deviceSerialNumber={id!}
            user={user}
            data={formData?.survey}
            isLoading={isSurveyLoading}
            />
        )}
        </div>

    );
};

export default DeviceWarrantyRegistrationPage;
